/**
 * Repairs garbled symbols in supplier descriptions: "CoolmaxÃÂ®" back to "Coolmax®".
 *
 * Somewhere between the supplier and Shopify, UTF-8 text was read as Windows-1252, once or
 * twice, and saved that way. Each accented letter or symbol became two or three characters
 * that start with Ã, Â or â. Those sequences never occur in real English or French - "Ã" is
 * never followed by a symbol, "Â" never by one either, "â€" never at all - so they can be
 * turned back without touching anything that was written correctly.
 *
 * The 47 products that had it were repaired in Shopify itself on 2026-09-27 (backup in
 * Syncshop/backups/description-mojibake-2026-09-27.json). This stays as the safety net for
 * products created later from the same supplier text.
 *
 * Only text inside the supplier description and the specification table is read, and only
 * text nodes, so markup and links are never rewritten.
 */
(function () {
  "use strict";

  // The Windows-1252 characters that stand in for the bytes 0x80-0x9F.
  var CP1252 = {
    "€": 0x80, "‚": 0x82, "ƒ": 0x83, "„": 0x84, "…": 0x85,
    "†": 0x86, "‡": 0x87, "ˆ": 0x88, "‰": 0x89, "Š": 0x8a,
    "‹": 0x8b, "Œ": 0x8c, "Ž": 0x8e, "‘": 0x91, "’": 0x92,
    "“": 0x93, "”": 0x94, "•": 0x95, "–": 0x96, "—": 0x97,
    "˜": 0x98, "™": 0x99, "š": 0x9a, "›": 0x9b, "œ": 0x9c,
    "ž": 0x9e, "Ÿ": 0x9f
  };

  /** The byte a garbled character stood for, or -1 if it cannot have been one. */
  function byteOf(ch) {
    var code = ch.charCodeAt(0);
    if (code <= 0xff) return code;
    return CP1252.hasOwnProperty(ch) ? CP1252[ch] : -1;
  }

  // A lead byte (Ã or Â, 0xC2-0xC3, or â for three-byte sequences) and its continuation bytes.
  var GARBLED = /[ÂÃ][\u0080-¿ -™Œ-ƒˆ˜]|â[\u0080-¿ -™Œ-ƒˆ˜]{2}/g;

  function repairOnce(text) {
    return text.replace(GARBLED, function (seq) {
      var bytes = [];
      for (var i = 0; i < seq.length; i++) {
        var b = byteOf(seq[i]);
        if (b < 0) return seq;
        bytes.push(b);
      }
      try {
        return decodeURIComponent(bytes.map(function (b) {
          return "%" + (b < 16 ? "0" : "") + b.toString(16);
        }).join(""));
      } catch (e) {
        return seq;
      }
    });
  }

  function repair(text) {
    // A twice-garbled symbol whose middle byte was lost on the way: "ÃÂ®" is "®". Taken first,
    // because read as ordinary garbling it would come out as "î".
    var start = text.replace(/ÃÂ(?=[ -¿])/g, "");
    // Twice-garbled text needs two passes; a third changes nothing.
    return repairOnce(repairOnce(start));
  }

  function clean(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (!/[ÂÃâ]/.test(text)) continue;
      var fixed = repair(text);
      if (fixed !== text) node.nodeValue = fixed;
    }
  }

  function run() {
    document.querySelectorAll(".product-description-supplier, .product-spec-table").forEach(clean);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();

  // A combined listing swaps the product section in place.
  if (typeof subscribe === "function") subscribe("section-refreshed", run);
})();
